import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl, FormattedDate } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import TableProvider from './TableProvider';
import EvaluatorChain from './evaluation/EvaluatorChain';
import Toolbar from './Toolbar';
import tableType from './type/table';
import TableContentVirtualized from './TableContentVirtualized';
import { setupTableData } from './data/tableData';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';
import { getLanguage, getConfigs } from '../../features/app/selectors';

const useStyles = makeStyles(theme => ({
  noItems: {
    padding: theme.spacing(4)
  },
  pagination: {
    background: theme.palette.background.default
  },
  infoContainer: {
    textAlign: 'center',
    padding: theme.spacing(4)
  },
  tableContentContainer: {
    height: 'calc(100% - 64px)'
  },
  tableRoot: {
    overflowX: 'auto'
  }
}));

const Table = ({
  columns = [],
  data = [],
  title,
  selectable = true,
  getObjectId,
  defaultSorting = [],
  showLanguageSelector = true,
  marketLanguage = false,
  actions = [],
  onRowClick,
  toolbarVisible = true,
  showOnlySearch = false
}) => {
  const classes = useStyles();
  const language = useSelector(getLanguage);
  const { formatDate } = useIntl();
  const formatDateConfig = useSelector(getConfigs).toJS().dateFormat;
  // console.log("formatDateConfig",useSelector(getConfigs).toJS())
  const tableData = setupTableData(
    data,
    columns,
    getObjectId,
    language,
    formatDateConfig
  );

  return (
    <TableProvider
      data={tableData}
      columns={columns}
      defaultSorting={defaultSorting}
      selectable={selectable}
      onRowClick={onRowClick}
    >
      <EvaluatorChain data={tableData}>
        {visibleData => (
          <>
            <Toolbar
              title={title}
              data={visibleData}
              showLanguageSelector={showLanguageSelector}
              marketLanguage={marketLanguage}
              actions={actions}
              visible={toolbarVisible}
              showOnlySearch={showOnlySearch}
            />
            <div className={classes.tableContentContainer}>
              <TableContentVirtualized data={visibleData} />
            </div>
          </>
        )}
      </EvaluatorChain>
    </TableProvider>
  );
};

Table.propTypes = tableType;

export default ImmutablePropsToJS(Table);
